export default __webpack_public_path__ + "static/media/section6-bg.71373206.png";